/**
 * Registered sign-in affordance (FR-2.2, FR-2.11).
 *
 * Renders nothing when Cognito is not configured (guest-only deploy / local dev) so
 * guests are never blocked (D-43.9). Otherwise it offers an entry button that opens the
 * app-owned {@link AuthPanel} (in-app sign-up / verify / sign-in / forgot / reset — no
 * redirect to the Cognito Hosted UI), or, once registered, a signed-in indicator +
 * "Sign out". Holds the single {@link useAuth} instance and passes it to the panel so
 * the trigger and the forms share one state machine.
 */

import { useAuth } from '../net/use-auth';
import { AuthPanel } from './auth/AuthPanel';

export function SignIn(): React.JSX.Element | null {
  const auth = useAuth();
  const { enabled, identity, open, openPanel, signOut } = auth;

  if (!enabled) return null; // no Cognito → guests only, show nothing

  const registered = identity !== null && !identity.isGuest;

  if (registered) {
    return (
      <div className="signin" data-testid="signin">
        <div className="signin__status">
          <span data-testid="signin-registered">Signed in</span>
          <button
            type="button"
            className="btn btn--ghost"
            data-testid="signin-signout"
            onClick={signOut}
          >
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="signin" data-testid="signin">
      {open ? (
        <AuthPanel auth={auth} />
      ) : (
        <button
          type="button"
          className="btn btn--ghost"
          data-testid="signin-button"
          onClick={() => openPanel('signIn')}
        >
          Sign in or create an account
        </button>
      )}
    </div>
  );
}
